import { render, staticRenderFns } from "./Index.html?vue&type=template&id=4b7dd788&scoped=true&external"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7dd788",
  null
  
)

export default component.exports